import { BaseModel } from "../base-model";

export interface ISmsTemplateParamModel {
    ModuleId?: number;
    PersonLanguageId?: number;
    PropertyIds?: any;
    IsOwner?: boolean;
    IsCandidate?: boolean;
    HasRelationMultiProperties?: boolean;
    Type?: number;
}

export class SmsTemplateParamModel extends BaseModel<ISmsTemplateParamModel> implements ISmsTemplateParamModel {
    ModuleId?: number;
    PersonLanguageId?: number;
    PropertyIds?: any;
    IsOwner?: boolean;
    IsCandidate?: boolean;
    HasRelationMultiProperties?: boolean;
    Type?: number;

    constructor(option?: ISmsTemplateParamModel) {
        super(option);
        this.ModuleId = this.ModuleId || 0;
        this.PersonLanguageId = this.PersonLanguageId || 3;
        this.PropertyIds = this.PropertyIds || null;

        this.IsOwner = this.IsOwner || false;
        this.IsCandidate = this.IsCandidate || false;
        this.HasRelationMultiProperties = this.HasRelationMultiProperties || false;
        this.Type = this.Type || null;
    }
}
export interface ISmsRenderParamModel {
    AppointmentId?: number;
    UserId?: number;
    PropertyId?: number;
    CurrentLanguage?: number;
    PersonLanguageId?: number;
    SMSTemplate?: string;
    PersonId?: number;
    PhoneNumber?: string;
}

export class SmsRenderParamModel extends BaseModel<ISmsRenderParamModel> implements ISmsRenderParamModel {
    AppointmentId?: number;
    UserId?: number;
    PropertyId?: number;
    CurrentLanguage?: number;
    PersonLanguageId?: number;
    SMSTemplate?: string;
    PersonId?: number;

    constructor(option?: ISmsRenderParamModel) {
        super(option);
        this.AppointmentId = this.AppointmentId != null ? this.AppointmentId: null;
        this.UserId = this.UserId != null ?this.UserId: null;
        this.PropertyId = this.PropertyId != null ? this.PropertyId : null;
        this.CurrentLanguage = this.CurrentLanguage != null ? this.CurrentLanguage : 3;
        this.PersonLanguageId = this.PersonLanguageId != null ? this.PersonLanguageId : 3;
        this.SMSTemplate = this.SMSTemplate || '';
        this.PersonId = this.PersonId != null ? this.PersonId : null;
    }
}